import { useMemo } from 'react'
import { isStandaloneMerchandiseOrder } from 'lib/order/orderUtils'
import { useOrdersByDepartureStatus } from './useOrdersByDepartureStatus'

export function useMerchandiseOrdersByStatus(): {
  loading: boolean,
  purchased: Array<App.Order>,
  cancelled: Array<App.Order>,
  hasTravelOrders: boolean,
} {
  const { loading, upcoming, previous, cancelled } = useOrdersByDepartureStatus()

  const merchandiseCancelled = useMemo(
    () => cancelled.filter(order => order.merchandiseItems.length > 0),
    [cancelled],
  )

  const merchandisePurchased = useMemo(
    () => [...upcoming, ...previous].filter(order => order.merchandiseItems.length > 0),
    [upcoming, previous],
  )

  const hasTravelOrders = useMemo(() => {
    return [
      ...upcoming,
      ...previous,
      ...cancelled,
    ].some(order => !isStandaloneMerchandiseOrder(order))
  }, [upcoming, previous, cancelled])

  return {
    loading,
    purchased: merchandisePurchased,
    cancelled: merchandiseCancelled,
    hasTravelOrders,
  }
}
